/* eslint-disable no-throw-literal */
import React, { useEffect, useState, useRef } from "react";
import DefaultPopup from "../shared/defPopup";
import "../App.scss";
import { useDispatch } from "react-redux";
import { headerCustomDisplaying, setCustomHeaderText } from "../store/mainSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import userAPI from "../api/userAPI";
import { isPartnerClalit, isPartnerMehudet } from "../store/partnerStore";
import AlmostFinishDialog from "../components/AlmostFinishDialog";

const AddCard = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const isClalit = useSelector(isPartnerClalit);
  const isMehudet = useSelector(isPartnerMehudet);
  const [isHaveCreditCardTrigger, setIsHaveCreditCardTrigger] = useState(false);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const navigate = useNavigate();
  const userParams = useSelector((state) => state.userSlice.userData);
  const cityAndClubs = useSelector((state) => state.appParamSlice.allAppParams);
  const [deleteAccountPopup, setDeleteAccountPopup] = useState(false);
  const timerIdRef = useRef(null);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [displayAlmostFinishDialog, setDisplayAlmostFinishDialog] = useState(!isClalit && location.state?.fromVenue);

  useEffect(() => {
    dispatch(headerCustomDisplaying(true));
    dispatch(setCustomHeaderText(t("CREDIT_CARD_DETAILS")));
    return () => {
      dispatch(headerCustomDisplaying(false));
      dispatch(setCustomHeaderText(""));
    };
  }, [t]);

  useEffect(() => {
    if (mainUserParams?.ID) {
      setIframeUrl(
        `https://freefit.co.il/Mobile/AppClientCard.aspx?ID=${mainUserParams.ID}&Phone=${mainUserParams.Phone}&Token=${mainUserParams.Token}`
      );
    }
  }, [mainUserParams]);

  useEffect(() => {
    if (location.state?.fromVenue) {
      const timerIdLocal = setInterval(async () => {
        try {
          const result = await userAPI.isClientHaveCreditCard({
            token: mainUserParams.Token,
            id: mainUserParams.ID,
            phone: mainUserParams.Phone,
          });

          if (result.data.Error === 0 && JSON.parse(result.data.Data).HasCreditCard) {
            setIsHaveCreditCardTrigger((prev) => !prev);
            setOpenConfirmPopup(true);
          } else if (result.data.Error !== 0) {
            setIsHaveCreditCardTrigger((prev) => !prev);
          }
        } catch (err) {
          console.error("Failed to check credit card:", err);
          setIsHaveCreditCardTrigger((prev) => !prev);
        }
      }, 3000);
      timerIdRef.current = timerIdLocal;
    }
    return () => {
      if (timerIdRef.current) {
        clearInterval(timerIdRef.current);
        timerIdRef.current = null;
      }
    };
  }, [location.state]);

  useEffect(() => {
    if (isHaveCreditCardTrigger) {
      if (timerIdRef.current) {
        clearInterval(timerIdRef.current);
        timerIdRef.current = null;
      }
    }
  }, [isHaveCreditCardTrigger]);

  useEffect(() => {
    if (location.state?.isExit) {
      setDeleteAccountPopup(location.state?.isExit);
    }
  }, [location.state]);

  return (
    <div className="main-page-container">
      {iframeUrl && (
        <iframe src={iframeUrl} title="add-card" frameBorder="0" className="add-card-iframe"></iframe>
      )}
      <DefaultPopup
        isOpen={openConfirmPopup}
        setIsOpen={setOpenConfirmPopup}
        bodyText={t("LETS_CONTINUE")}
        bodyTextColor={"rgba(27, 41, 107, 1)"}
        subBodyText={t("CLICK_CONTINUE_TO_PROCEED")}
        btnText={t("PHONE_VALIDATION.CONTINUE")}
        padding={false}
        onConfirmClick={() => {
          navigate(`/venue/${location.state.clubId}`, {
            state: {
              price: location.state.price,
              clubId: location.state.clubId,
              clubName: location.state.clubName,
              ignoreApiCall: isMehudet,
            },
          });
        }}
      />
      {!isClalit && (
        <AlmostFinishDialog
          open={displayAlmostFinishDialog}
          onClose={() => {
            setDisplayAlmostFinishDialog(false);
          }}
        />
      )}
    </div>
  );
};

export default AddCard;
